import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function ButtonWidget(props) {
  var options = props.options,
    value = props.value,
    required = props.required,
    disabled = props.disabled,
    readonly = props.readonly,
    autofocus = props.autofocus,
    onChange = props.onChange;
  var _options$enumOptions = options.enumOptions,
    enumOptions = _options$enumOptions === void 0 ? [] : _options$enumOptions;
  var buttonLayout = options.buttonLayout || "horizontal";
  var autoSubmit = options.autoSubmit !== false;

  // Parse buttonColors from JSON string if needed
  var buttonColors = [];
  var rawColors = options.buttonColors;
  if (rawColors) {
    if (Array.isArray(rawColors)) {
      buttonColors = rawColors;
    } else if (typeof rawColors === 'string') {
      try {
        var parsed = JSON.parse(rawColors);
        if (Array.isArray(parsed)) {
          buttonColors = parsed;
        } else if (typeof parsed === 'string') {
          // Double-encoded
          var doubleParsed = JSON.parse(parsed);
          if (Array.isArray(doubleParsed)) {
            buttonColors = doubleParsed;
          }
        }
      } catch (e) {
        console.error('Failed to parse buttonColors:', e, rawColors);
      }
    }
  }
  var handleClick = function handleClick(e, optionValue) {
    onChange(optionValue);
    if (autoSubmit && e.target) {
      var target = e.target;
      setTimeout(function () {
        var form = target.closest('form');
        if (form) {
          var submitButton = form.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.click();
          }
        }
      }, 100);
    }
  };
  var containerStyle = buttonLayout === "vertical" ? {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px"
  } : {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "10px"
  };
  return /*#__PURE__*/_jsx("div", {
    className: "field-buttons-group",
    style: containerStyle,
    children: enumOptions.map(function (option, i) {
      var isSelected = option.value === value;
      var buttonColor = Array.isArray(buttonColors) ? buttonColors[i] : null;

      // Build inline styles - use custom color or default
      var buttonStyle = buttonColor ? {
        backgroundColor: buttonColor,
        borderColor: buttonColor,
        color: '#fff',
        padding: '10px 16px',
        fontSize: '18px',
        lineHeight: '1.33',
        borderRadius: '6px',
        border: '1px solid transparent',
        cursor: 'pointer',
        fontWeight: 'normal',
        textAlign: 'center',
        verticalAlign: 'middle',
        touchAction: 'manipulation',
        userSelect: 'none'
      } : {};

      // Only use Bootstrap classes if NO custom color
      var btnClass = buttonColor ? isSelected ? "active" : "" : "btn btn-primary btn-lg ".concat(isSelected ? "active" : "");
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        className: btnClass,
        disabled: disabled || readonly,
        autoFocus: autofocus && i === 0,
        onClick: function onClick(e) {
          return handleClick(e, option.value);
        },
        style: buttonStyle,
        children: option.label
      }, i);
    })
  });
}
export default ButtonWidget;
//# sourceMappingURL=ButtonWidget.js.map